import api from '@http/api';

export interface IOrigemEspecifica {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IOrigemMacro {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IMotivo {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IFormaContribuicao {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface ITipoCorrespondecia {
  id: string;
  descricao: string;
  data_cadastro: string;
  status_ativo: boolean;
}

export interface IContatoOffline {
  contato_offline_id: string;
  bairro: string;
  cidade_id: string;
  estado_id: string;
  cep: string;
  logradouro: string;
  endereco: string;
  numero: string;
  complemento: string;
  status_ativo: string;
  Distrito: string;
}

export interface IContatoOnline {
  contato_online_descricao: string;
}

export interface IUpdatePerfil {
  id: string;
  motivo_cadastro_id: string;
  nome_fantasia: string;
  origem_especifica_id: string;
  forma_contribuicao_id: string;
  tipo_correspondencia_id: string;
  status_ativo: number;
  valor_padrao_doacao: number;
  recorrencia_meses: number;
  contato_offline: IContatoOffline;
  telefone_fixo: IContatoOnline;
  telefone_comercial: IContatoOnline;
  celular: IContatoOnline;
  whatsapp: IContatoOnline;
  email: IContatoOnline;
  estrangeiro: string;
  debito_automatico: {
    id?: number;
    id_convenio?: number;
    id_banco?:  number;
    nome_cedente?: string;
    agencia_numero: string;
    agencia_digito: string;
    conta_numero: string;
    conta_digito: string;
    operacao: string;
    valor: number;
    dia_vencimento: string;
    recorrente: 0;
    status_ativo: 0;
    id_perfil?: number;
    data_cadastro?: Date;
    data_modificacao?: Date;
  };
  debito_automatico_desativacao_motivo?: {
    id: number;
    descricao: string;
  };

  debito_conta_energia: {
    id?: number;
    id_convenio?: number;
    conta_contrato_numero: string;
    recorrencia: number;
    valor: number;
    status_ativo: true;
    id_perfil?: number;
    data_cadastro?: Date;
    data_modificacao?: Date;
  };

  perfil_recorrencia_doacao: {
    id?: number;
    intervalo_mes: number;
    dia: number;
    status_ativo: true;
  };
}


//TRIAGEM
/*export interface IUpdatePerfil {
  perfil:{
  id: string;
  nome: null;
  nome_fantasia: null;
  motivo_cadastro_id: null;
  origem_especifica_id: null;
  forma_contribuicao_id: null;
  tipo_correspondencia_id: null;
  tipo_perfil_id: null,
  status_ativo: null;
  valor_padrao_doacao: null;
  },

  perfil_contato_offline: {
    id: null;
    bairro: null;
    cidade_id: null;
    estado_id: null;
    distrito: null;
    cep: null;
    logradouro: null;
    endereco: null;
    complemento: null;
    status_ativo: null;
  },
  perfil_contato_online: {
    email: null;
    celular: null;
    comercial: null;
    residencial: null;
    whatsapp: null;
  },


  perfil_recorrencia: {
    id?: null;
    intervalo_mes: null;
    status_ativo: null;
  };

  perfil_debito_automatico: {
    id?: null;
    id_convenio?: null;
    id_banco?:  null;
    nome_cedente?: null;
    agencia_numero: null;
    agencia_digito: null;
    conta_numero: null;
    conta_digito: null;
    operacao: null;
    valor: null;
    dia_vencimento: null;
    recorrente: null;
    status_ativo: null;
    status_inativo_motivo: null;
  };

  perfil_conta_energia: {
    id?: null;
    id_convenio?: null;
    conta_contrato_numero: null;
    recorrencia: null;
    valor: null;
    status_ativo: null;
  };

}*/

export interface IDesativacaoDebitoAutomaticoMotivos {
  id: number;
  descricao: string;
}

class ComponentPerfilServices {
  public async loadOrigemEspecifica() {
    return await api
      .get<IOrigemEspecifica[]>('/api/OrigemEspecifica/GetOrigensEspecificas')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadOrigemMacro() {
    return await api
      .get<IOrigemMacro[]>('/api/OrigemMacro/GetOrigensMacro')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadMotivos() {
    return await api
      .get<IMotivo[]>('/api/MotivoCadastro/GetMotivosCadastros')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadFormaContribuicao() {
    return await api
      .get<IFormaContribuicao[]>('/api/FormaContribuicao/GetFormasContribuicao')
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async loadTiposCorrespondecia() {
    return await api
      .get<ITipoCorrespondecia[]>(
        '/api/TipoCorrespondencia/GetTiposCorrespondecia',
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

  public async UpdatePerfil({
    contato_offline,
    forma_contribuicao_id,
    id,
    motivo_cadastro_id,
    nome_fantasia,
    origem_especifica_id,
    status_ativo,
    tipo_correspondencia_id,
    valor_padrao_doacao,
    recorrencia_meses,
    celular,
    email,
    telefone_comercial,
    telefone_fixo,
    whatsapp,
    debito_automatico,
    debito_conta_energia,
    perfil_recorrencia_doacao,
    debito_automatico_desativacao_motivo,
    estrangeiro
  }: IUpdatePerfil) {
    return await api
      .put('/api/Perfil/UpdatePerfilById', {
        contato_offline,
        forma_contribuicao_id,
        id,
        motivo_cadastro_id,
        nome: '',
        nome_fantasia,
        origem_especifica_id,
        status_ativo,
        tipo_correspondencia_id,
        valor_padrao_doacao,
        recorrencia_meses,
        celular,
        email,
        telefone_comercial,
        telefone_fixo,
        whatsapp,
        debito_automatico,
        debito_conta_energia,
        perfil_recorrencia_doacao,
        debito_automatico_desativacao_motivo,
        estrangeiro
      })

      .then(response => {
        return {
          error: false,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }

  //TRIAGEM
  /*public async UpdatePerfil({
   perfil,
   perfil_contato_offline,
   perfil_contato_online,
   perfil_recorrencia,
   perfil_debito_automatico,
   perfil_conta_energia,

  }: IUpdatePerfil) {
    return await api
      .post('/api/Perfil/EncaminhaAlteracoesParaTriagem', {
        perfil,
   perfil_contato_offline,
   perfil_contato_online,
   perfil_recorrencia,
   perfil_debito_automatico,
   perfil_conta_energia,
      })

      .then(response => {
        return {
          error: false,
        };
      })
      .catch(error => {
        return {
          error: true,
        };
      });
  }*/

  public async GetDebitoDesativacaoMotivos() {
    return await api
      .get<IDesativacaoDebitoAutomaticoMotivos[]>(
        'api/Financeiro/GetDebitoDesativacaoMotivos',
      )
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }
}

export default ComponentPerfilServices;
